import React from 'react';
import { Input, Button, Text, Link } from '../../../ui-kit';

import '../styles/_welcome-guest.scss';










const PRIVACY_POLICY_URL = 'https://shootsta.com/privacy';

function openPrivacyPolicyPage() {
  window.open(PRIVACY_POLICY_URL, '_blank');
}

export default function VideoAnonymousUserForm({
  displayLoginForm,
  handleAnonymousUser,
  updateName,
  busy,
  error,
  disabled
}) {
  return (
    <>
      <div className="login-modal__body">
        <div className="login-modal__body__input-container">
          <Input
            labelProps={{ required: true }}
            label="Name"
            className="login-modal__input"
            onChange={updateName}
            placeholder="Enter name" />

        </div>

        <Button disabled={disabled} className="login-modal__button" onClick={handleAnonymousUser} busy={busy}>
          Start Commenting
        </Button>

        <Text className="login-modal__or-text" centered>or</Text>

        <Button type="SECONDARY" className="login-modal__button" onClick={displayLoginForm}>
          Log Back In
        </Button>
      </div>
      <div className="welcome-guest__footer">
        <Text label>
          By completing this action you agree to Shootsta’s
          <Link className="welcome-guest__footer__link" onClick={openPrivacyPolicyPage}>Privacy Policy</Link>
          .
        </Text>
      </div>
      {error ?
      <Text danger prefixIcon="alert" prefixIconColor="redApple">Something went wrong</Text> :
      null}

    </>);

}